import { Injectable } from '@angular/core'
import { StorageApiService } from 'src/app/builder-services/api/storage.api.service'

/**
 * Project asset storage for the order/settings/header/footer screens.
 *
 * Previously held its own Supabase Storage calls; now a thin wrapper over the
 * stacks-agents storage endpoints, which own the credentials and rebuild every
 * path under the project folder they've verified the caller owns.
 */
@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private storageApi: StorageApiService) {}

  /**
   * Uploads a file under the project's storage folder.
   *
   * @param file - The file to upload
   * @param projectId - The owning project
   * @param path - Path within the project folder, e.g. "images/website_logo.png"
   * @returns The uploaded file's public URL
   */
  async uploadFile(file: File, projectId: string | number, path: string): Promise<string> {
    return this.storageApi.upload(file, projectId, path)
  }

  /** Photos a customer attached to one product of one order. */
  async getProductPhotos(projectId: string | number, userId: string, productId: string): Promise<{ path: string; url: string }[]> {
    return this.storageApi.getOrderPhotos(projectId, userId, productId)
  }
}
